import cx from "classnames";

import { UserOutlined } from "@ant-design/icons";
import { Avatar, Space } from "antd";

import styles from "../styles/MyTeamHeader.module.css";

function MyTeamHeader({ className = "" }) {
  return (
    <div className={cx("card", styles.container, className)}>
      <Space size={20} align="center">
        <Avatar shape="square" size={56} icon={<UserOutlined />} />
        <Space size={4} direction="vertical">
          <p>All Employee</p>
          <small>Company 7 Co., Ltd.</small>
        </Space>
      </Space>
    </div>
  );
}

export default MyTeamHeader;
